document.addEventListener('DOMContentLoaded', () => {
  const reviewsWidget = document.querySelector('.reviews');
  
  if (!reviewsWidget) return;
  
  const reviewsDataAttr = reviewsWidget.dataset.reviewsData;
  const starsContainer = reviewsWidget.querySelector('.reviews__stars');
  const countElement = reviewsWidget.querySelector('.reviews__count-number');
  const ratingElement = reviewsWidget.querySelector('.reviews__rating-number');
  const loadingElement = reviewsWidget.querySelector('.reviews__loading');
  const errorElement = reviewsWidget.querySelector('.reviews__error');
  
  // Show loading state
  function showLoading() {
    loadingElement.style.display = 'block';
    errorElement.style.display = 'none';
    reviewsWidget.querySelector('.reviews__summary').style.opacity = '0.5';
  }
  
  // Hide loading state
  function hideLoading() {
    loadingElement.style.display = 'none';
    reviewsWidget.querySelector('.reviews__summary').style.opacity = '1';
  }
  
  // Show error state
  function showError() {
    hideLoading();
    errorElement.style.display = 'block';
  }
  
  // No longer needed - using pre-calculated averageRating from metafield
  
  // Update star display based on rating
  function updateStars(rating) {
    const stars = starsContainer.querySelectorAll('.reviews__star');
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    
    stars.forEach((star, index) => {
      const starSvg = star.querySelector('svg');
      
      if (index < fullStars) {
        // Full star
        star.classList.add('reviews__star--full');
        star.classList.remove('reviews__star--half', 'reviews__star--empty');
      } else if (index === fullStars && hasHalfStar) {
        // Half star - use the provided half-star SVG
        star.classList.add('reviews__star--half');
        star.classList.remove('reviews__star--full', 'reviews__star--empty');
        // Replace with the custom half-star SVG
        starSvg.outerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M7.99989 12.5579C8.15189 12.5579 8.30389 12.5999 8.43989 12.6846L12.0886 14.9492L11.0499 10.2592L14.3879 6.49991H10.3852C10.0526 6.49991 9.75256 6.30258 9.62056 5.99724L7.99989 2.25724L6.37856 5.99791C6.24722 6.30258 5.94722 6.49991 5.61456 6.49991H1.61189L4.94922 10.2599L3.91122 14.9492L7.56056 12.6839C7.69589 12.5999 7.84789 12.5579 7.99989 12.5579ZM3.66322 16.1332C3.49389 16.1332 3.32522 16.0812 3.18122 15.9792C2.90656 15.7852 2.77656 15.4472 2.84922 15.1192L3.86256 10.5426L0.617889 6.88658C0.397223 6.63791 0.345223 6.29458 0.481223 5.99124C0.617889 5.68858 0.909223 5.49991 1.24122 5.49991H5.50456L7.23522 1.50658C7.36789 1.20191 7.66789 1.00458 7.99989 1.00458C8.33189 1.00458 8.63189 1.20191 8.76389 1.50658H8.76456L10.4946 5.49991H14.7586C15.0912 5.49991 15.3819 5.68791 15.5179 5.99124C15.6546 6.29458 15.6026 6.63724 15.3819 6.88658L12.1372 10.5419L13.1506 15.1192C13.2226 15.4472 13.0926 15.7852 12.8186 15.9792C12.5446 16.1732 12.1826 16.1846 11.8972 16.0072L7.99989 13.5886L4.10256 16.0079C3.96722 16.0912 3.81522 16.1332 3.66322 16.1332Z"
                fill="#C4C8CF"/>
          <mask id="mask0_1827_89" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="9" height="17">
            <rect y="0.5" width="8.5" height="16" fill="white"/>
          </mask>
          <g mask="url(#mask0_1827_89)">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M3.66309 16.1335C3.49443 16.1335 3.32576 16.0815 3.18109 15.9795C2.90709 15.7855 2.77643 15.4475 2.84909 15.1195L3.86309 10.5422L0.618427 6.88682C0.397761 6.63749 0.345094 6.29482 0.481761 5.99149C0.617761 5.68882 0.909094 5.50015 1.24176 5.50015H5.50509L7.23509 1.50682C7.36776 1.20216 7.66776 1.00482 7.99976 1.00482C8.33176 1.00482 8.63243 1.20216 8.76443 1.50682H8.76509L10.4951 5.50015H14.7584C15.0911 5.50015 15.3824 5.68815 15.5184 5.99149C15.6551 6.29482 15.6031 6.63749 15.3824 6.88615L12.1371 10.5415L13.1504 15.1195C13.2224 15.4475 13.0924 15.7855 12.8184 15.9795C12.5451 16.1735 12.1831 16.1848 11.8971 16.0075L7.99976 13.5888L4.10243 16.0082C3.96776 16.0915 3.81509 16.1335 3.66309 16.1335Z"
                  fill="#C37600"/>
          </g>
          <mask id="mask1_1827_89" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="8" height="17">
            <rect y="0.5" width="7.5" height="16" fill="white"/>
          </mask>
          <g mask="url(#mask1_1827_89)">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M7.99964 12.5583C8.15164 12.5583 8.30364 12.6003 8.4403 12.685L12.0883 14.949L11.1056 10.5083C11.071 10.3523 11.113 10.1883 11.2196 10.0683L14.3876 6.50029H10.3856C10.0523 6.50029 9.75231 6.30296 9.62031 5.99762L7.99964 2.25696L6.37897 5.99829C6.24697 6.30296 5.94697 6.50029 5.6143 6.50029H1.6123L4.7803 10.069C4.8863 10.189 4.92897 10.353 4.8943 10.509L3.91097 14.949L7.5603 12.6843C7.69564 12.6003 7.84764 12.5583 7.99964 12.5583Z"
                  fill="#FFE200"/>
          </g>
        </svg>`;
      } else {
        // Empty star
        star.classList.add('reviews__star--empty');
        star.classList.remove('reviews__star--full', 'reviews__star--half');
        // Replace with empty star SVG
        starSvg.outerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99964 12.5583C8.15164 12.5583 8.30364 12.6003 8.4403 12.685L12.0883 14.949L11.1056 10.5083C11.071 10.3523 11.113 10.1883 11.2196 10.0683L14.3876 6.50029H10.3856C10.0523 6.50029 9.75231 6.30296 9.62031 5.99762L7.99964 2.25696L6.37897 5.99829C6.24697 6.30296 5.94697 6.50029 5.6143 6.50029H1.6123L4.7803 10.069C4.8863 10.189 4.92897 10.353 4.8943 10.509L3.91097 14.949L7.5603 12.6843C7.69564 12.6003 7.84764 12.5583 7.99964 12.5583Z" fill="none" stroke="#E5E5E5" stroke-width="1"/>
        </svg>`;
      }
    });
    
    starsContainer.dataset.rating = rating.toFixed(1);
  }
  
  // Process reviews from metafield data
  function processReviews() {
    if (!reviewsDataAttr) {
      console.log('No reviews data attribute found');
      showError();
      return;
    }
    
    showLoading();
    
    try {
      // Parse the JSON data from the metafield
      const reviewsData = JSON.parse(reviewsDataAttr);
      
      // Handle case where metafield might be empty or null
      if (!reviewsData) {
        countElement.textContent = '(0)';
        ratingElement.textContent = '0.0';
        countElement.setAttribute('aria-label', 'No reviews yet')
        ratingElement.setAttribute('aria-label', 'No reviews yet')
        updateStars(0);
        hideLoading();
        return;
      }
      
      // Use provided averageRating and reviewCount instead of calculating
      const averageRating = reviewsData.averageRating || 0;
      const totalReviews = reviewsData.reviewCount || (reviewsData.reviews ? reviewsData.reviews.length : 0);
      
      // Update UI
      countElement.textContent = '(' + totalReviews + ')';
      ratingElement.textContent = averageRating.toFixed(1);
      countElement.setAttribute('aria-label', 'Read '+ totalReviews + ' customer reviews');
      ratingElement.setAttribute('aria-label', 'Rated '+ averageRating.toFixed(1) + ' out of 5 stars');
      updateStars(averageRating);
      
      hideLoading();
      
    } catch (error) {
      showError();
    }
  }
  
  // Initialize reviews widget
  processReviews();
})